import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { css } from '@bd/bdui-styles/emotion';
import { Image } from '@bd/bdcore-utilities';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import ContentBanner from '../../components/ContentBanner';
import LivingMenu from '../../components/menus/Living';
import { colors, typography } from '../../styles';

const styles = css`
  .PageSection_wrapper {
    max-width: 100%;
    padding: 20px 0;
    @media (min-width: 768px) {
      padding: 50px 0;
    }
  }
    .ActivitiesWrapper {
        padding: 20px 0;
        background-color: ${colors.color4};
        @media (min-width: 768px) {
          padding: 50px 0;
        }
    }
    .Activity {
      width: 100%;
    }
    .ActivityImage {
      object-fit: cover;
      width: 100%;
      max-height: 300px;
      @media(min-width: 768px){
        max-height: 190px;
      }
      @media(min-width: 1200px){
        max-height: 230px;
      }
    }
    .ActivityTitle {
      font-family: ${typography.Serif};
      color: ${colors.color1};
      text-transform: uppercase;
      font-weight: 400;
      letter-spacing: 1px;
      font-size: 20px;
      margin: 5px 0 15px;
      @media (min-width: 992px) {
        font-size: 22px;
      }
      @media (min-width: 1200px) {
        font-size: 24px;
      }
    }
    .ActivityCopy {
      font-weight: 300;
      line-height: 1.5;
      font-size: 15px;
      letter-spacing: .5px;
      @media (min-width: 992px) {
        font-size: 16px;
      }
      p {
        font-weight: 300;
        line-height: 1.5;
        font-size: 15px;
        letter-spacing: .5px;
        @media (min-width: 992px) {
          font-size: 16px;
        }
      }
    }
    .ActivityTimes p {
      font-size: 13px;
      font-weight: 600;
    }

    .GalleryWrapper {
      padding: 50px 0;
    }
    .ActivitiesMap {
      padding: 30px 15px;
      width: 100%;
      @media (min-width: 992px) {
        padding: 50px 0 70px 0;
      }
    }
`;

function Activities({ page }) {
  const welcome = get(page, 'welcome_section[0]');
  return (
    <PageWrapper className={styles}>
      <PageHelmet page={page} />
      <InsideHeader
        title={`${page.meta.name}`}
        postTitle={get(page, 'page_subtitle')}
        background={get(page, 'page_image.contentUrl')}
        video={get(page, 'header_video.contentUrl')}
      />
      <LivingMenu />
      <ContentBanner
        title={get(welcome, 'title')}
        lead={get(welcome, 'lead_copy')}
        image={get(welcome, 'image.contentUrl')}
        video={get(welcome, 'video')}
      />
      <div className="ActivitiesWrapper">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-xl-10 mx-auto">
              <Image
                src={page.activities_map.contentUrl}
                alt="Activites Map"
                className="ActivitiesMap"
                width={2000}
                height={2000}
                preserve
              />
            </div>
          </div>
          <div className="row">
            {
            get(page, 'activities', []).length > 0 &&
             get(page, 'activities').map(item => (
               <div key={item._id} className="Activity col-md-6 col-lg-4">
                 <Image
                   className="ActivityImage"
                   src={get(item, 'image.contentUrl')}
                   alt={item.title}
                   height={800}
                   width={800}
                 />
                 <h3 className="ActivityTitle">{item.title}</h3>
               </div>
             ))
            }
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}

Activities.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'activities',
})(Activities);



// WEBPACK FOOTER //
// ./src/pages/Activities/index.js